// extracted by mini-css-extract-plugin
export default {"tabsContainer":"b8MG6d","tabs":"duKcHz"};